<script>
import { RichText } from "prismic-dom";
import linkResolver from "src/link-resolver";

export default {
  name: "PrismicRichText",
  functional: true,
  props: {
    field: {
      type: Array,
      required: true
    },
    htmlSerializer: {
      type: Function,
      required: false
    },
    wrapper: {
      type: String,
      required: false,
      default: "div"
    }
  },
  render(h, { props, data }) {
    const { field, htmlSerializer, wrapper } = props;
    if (field.length === 0) return;

    let innerHTMLs = RichText.asHtml(field, linkResolver, htmlSerializer);
    // there is an issue between the l and the '
    let innerHTML = innerHTMLs.replace("l&#39;", "l<span class='apostrophe-spacing'>'</span>");

    return h(wrapper, {
      ...data,
      class: {
        "t-cms": true
      },
      domProps: {
        innerHTML
      }
    });
  }
};
</script>
